
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/strona/[page]",
      function () {
        return require("private-next-pages/blog/strona/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/strona/[page]"])
      });
    }
  